import React, { useState } from "react";
import "./AgahiBox.css";
import moment from "jalali-moment";
import { BsCheckLg, BsPlusSquare } from "react-icons/bs";
import { RiUploadCloudLine } from "react-icons/ri";
import { BiGlasses, BiTrash } from "react-icons/bi";
import { HiOutlinePencilAlt } from "react-icons/hi";

function AgahiBox(props) {
    const [tick, setTick] = useState(false);
    return (
        <div className="BuildingBox" style={{ display: "flex" }}>
            <div className="BuildingBoxItem1" style={{ flexGrow: 1 }}>
                <div className="SCheckboxTick BuildingBoxItem1Tick" onClick={() => setTick(!tick)}>
                    {tick ? <BsCheckLg /> : <></>}
                </div>
                <span className="BuildingBoxItemTitle BuildingBoxItemTitle1">{props.index + 1}</span>
            </div>

            <div className="BuildingBoxItem2" style={{ flexGrow: 3, minWidth: "200px" }}>
                <span className="BuildingBoxItemTitle">{props.data.id}</span>
            </div>
            <div className="BuildingBoxItem3" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{moment(props.data.updatedAt).locale("fa").format("YYYY/MM/DD")}</span>
            </div>
            <div className="BuildingBoxItem4" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{props.data.advertiseType}</span>
            </div>
            <div className="BuildingBoxItem5" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{props.data.buildingType}</span>
            </div>
            <div className="BuildingBoxItem7" style={{ flexGrow: 2 }}>
                <span className="BuildingBoxItemTitle">{props.data.advertiseUseType}</span>
            </div>
            <div className="BuildingBoxItem7" style={{ flexGrow: 2 }}>
                {!props.data.isDeleted ? (
                    <span className="BuildingBoxItemTitle" style={{ backgroundColor: "#009432", color: "#C4E538", padding: "6px 18px", borderRadius: "12px" }}>
                        نمایش
                    </span>
                ) : (
                    <span className="BuildingBoxItemTitle" style={{ backgroundColor: "#6F1E51", color: "#ff7979", padding: "6px 18px", borderRadius: "12px" }}>
                        {props.data.isDeleted}
                    </span>
                )}
            </div>

            <div className="BuildingBoxItem8" style={{ flexGrow: 2 }}>
                <div className="BuildingBoxItem8Icons">
                    <div className="BuildingBoxItem8Icon">
                        <RiUploadCloudLine />
                    </div>
                    <div className="BuildingBoxItem8Icon">
                        <BiGlasses />
                    </div>
                    <div className="BuildingBoxItem8Icon BuildingBoxItem8IconLast">
                        <BiTrash />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AgahiBox;
